module.exports = __webpack_public_path__ + "static/media/29ADMSPC27.df45c11e.jpg";